'use client';
import { SessionContext } from '@benzinga/session-context';
import { StockSymbol, UUID } from '@benzinga/session';
import React from 'react';
import { useActiveWorkspaceSubscriber } from '@benzinga/pro-tools';

import { HoldingsQuote } from '@benzinga/quotes-v3-holdings-manager';
import { WatchlistHoldingsManager } from '@benzinga/watchlist-holdings-manager';

export const useWatchlistHoldingsQuotes = (watchlistId: UUID, fields: Set<keyof HoldingsQuote>) => {
  const feed = useWatchlistHoldingsQuotesCol(watchlistId, fields, quote => {
    setQuotes(prev => {
      const index = prev.findIndex(q => q.symbol === quote.symbol);
      if (index === -1) {
        return [...prev, quote];
      }
      prev[index] = quote;
      return [...prev];
    });
  });
  const [quotes, setQuotes] = React.useState<HoldingsQuote[]>(feed.getCachedValue());
  return quotes;
};

export const useWatchlistHoldingsQuotesCol = (
  watchlistId: UUID,
  fields: Set<keyof HoldingsQuote>,
  updateCallback: (info: HoldingsQuote) => void,
  visibleSymbols?: StockSymbol[],
) => {
  const session = React.useContext(SessionContext);
  const watchlistHoldingManager = session.getManager(WatchlistHoldingsManager);

  const feed = React.useMemo(() => {
    return watchlistHoldingManager.createWatchlistFeed(watchlistId, true, visibleSymbols);
  }, [visibleSymbols, watchlistHoldingManager, watchlistId]);

  useActiveWorkspaceSubscriber(
    feed,
    event => {
      switch (event.type) {
        case 'watchlist-holdings:quote-update':
          updateCallback(event.quote);
          break;
        case 'watchlist-holdings:update':
          event.quotes.forEach(updateCallback);
      }
    },
    fields,
  );

  return feed;
};
